// Uses the Browser URL API to calculate params

export default function calculateParamsFromUrl() {
  return new URL(window.location.href).searchParams;
}
